import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { catchError, map, Observable, Observer, of, throwError } from 'rxjs';
import { Shop } from '../../shared/entities/shop';
import { SurrogateKeyService } from './surrogate-key.service';
import { MulticastObserverFactoryService } from './multicast-observer-factory.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({
  providedIn: 'root'
})
export class ShopInfoService {
  constructor(
    private platform: PlatformInformationService,
    private client: HttpClient,
    private multicastObserverFactory: MulticastObserverFactoryService,
    private surrogateKeyService: SurrogateKeyService,
    private localizeRouterService: LocalizeRouterService
  ) {}

  private locationMap = new Map<string, Observable<Shop>>();

  getLocationById(id: string): Observable<Shop> {
    if (this.locationMap.has(id)) {
      return this.locationMap.get(id);
    } else {
      const url = this.getLocationByIdApiUrl(id, 'EUR', this.platform.getCurrentPartner());
      const multicast = this.multicastObserverFactory.create<Shop>((observer: Observer<Shop>) => {
        this.client
          .get<Shop>(url, { headers: { Accept: 'application/json' }, observe: 'response' })
          .pipe(
            map(response => {
              if (!this.platform.getIsBrowser() && response.status === 200) {
                this.surrogateKeyService.addSurrogateKeys(['shop-' + response.body.id]);
              }
              const shop = new Shop(response.body);
              this.locationMap.set(id, of(shop));
              return shop;
            }),
            catchError(e => {
              if (e.error.code === 404000) {
                const route = this.localizeRouterService.translateRoute('/SKIHIREENTRY') as string;
                window.location.href = route;
              }
              return throwError(() => {
                new Error('Could not load location by id: ' + url);
              });
            })
          )
          .subscribe({
            next: shop => {
              observer.next(shop);
              observer.complete();
            },
            error: e => {
              observer.error(e);
              observer.complete();
            }
          });
      });

      this.locationMap.set(id, multicast);
      return this.locationMap.get(id);
    }
  }

  private getLocationByIdApiUrl(id: string, currency: string, partner: string): string {
    if (partner) {
      return this.platform
        .getApiEndpointFor('getLocationByIdParnterApi')
        .replace('%lang%', this.platform.getDefaultLangForPlatform())
        .replace('%id%', id)
        .replace('%currency%', currency)
        .replace('%partner%', partner);
    }
    return this.platform
      .getApiEndpointFor('getLocationByIdApi')
      .replace('%lang%', this.platform.getDefaultLangForPlatform())
      .replace('%id%', id)
      .replace('%currency%', currency);
  }
}
